import { memo } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  CashSpecialIcon,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

/**
 * Starter base landing. Same anatomy as the send landing (hero mark, title,
 * body, footer CTA) with generic copy; new starter screens build on top of it.
 * The CTA is inert: starter has no next step wired in the gallery.
 */
export const LandingPage = memo(() => {
  const { t } = useTranslation("starter");
  const { theme } = useStore();

  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, bodyCopy, dropzoneColors, backgroundIcon } =
    colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <CashSpecialIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("landing.greeting")}
              highlightColor={TITLE_COLOR}
              secudnary={t("landing.subtitle")}
              secudnaryColor={TITLE_COLOR}
            />
            <BodyCopy textColor={bodyCopy}>{t("landing.body")}</BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => {}}
          >
            {t("landing.cta")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
